// SinglePropertyLayoutTab/components/FieldOption.js
const FieldOption = ({ option, onSelect }) => (
  <div 
    className="hvnly--builder---api_property__singleProperty__builder___field_option"
    onClick={() => onSelect(option)}
  >
    <div className="hvnly--builder---api_property__singleProperty__builder___field_icon">
      <i className={`fas fa-${option.icon}`}></i>
    </div>
    <div className="hvnly--builder---api_property__singleProperty__builder___field_info">
      <h4>{option.label}</h4>
      <p>{option.description}</p>
    </div>
  </div>
);

export default FieldOption;